function startCountdown() {
    // Set the target date to be 24 hours from the current moment
    var countdown = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours from now
    
    var x = setInterval(function() {
        var now = new Date().getTime();
        var distance = countdown - now;

        // Calculate days, hours, minutes, and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the countdown
        document.getElementById("timer").innerHTML = days + "d " + hours + "h "
            + minutes + "m " + seconds + "s ";

        // If the countdown has expired, reset it to 24 hours from now
        if (distance < 0) {
            countdown = new Date().getTime() + 24 * 60 * 60 * 1000; // Set new target date (24 hours later)
        }
    }, 1000);
}

